import { render, staticRenderFns } from "./createAdvise.vue?vue&type=template&id=1accb175&scoped=true&"
import script from "./createAdvise.vue?vue&type=script&lang=js&"
export * from "./createAdvise.vue?vue&type=script&lang=js&"
import style0 from "./createAdvise.vue?vue&type=style&index=0&id=1accb175&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1accb175",
  null
  
)

export default component.exports